import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select";
import { getdistrictlist } from "store/participantdistrict/actions";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
// import {  } from "store/Payment/actions";
import {
  getAnalytelist,
  getanalytereport1,
} from "store/databaseofunits/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";

class AnalyteReport1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameFilter: "",
      idFilter: "",
      districtFilter: "",
      participantFilter: "",
      manufacturerFilter: "",
      originFilter: "",
      equipmentFilter: "",
      schemeFilter: "",
      schemeModalOpen: false,
      amountFilter: "",
      discountFilter: "",
      GetAnalyte: [],
      tableKey: 0,
      feedbackMessage: "",
      errorMessage: "",
      editModalOpen: false,
      selectedRow: null,
      analytes: [], // ✅ initialize
      schemes: [], // ✅ initialize
      cycles: [], // ✅ initialize
      rounds: [],
      filteredSchemes: [],
      filteredCycles: [],
      filteredRounds: [],
      analyteFilter: "",
      schemeFilter: "",
      cycleFilter: "",
      roundFilter: "", // ✅ initialize
      ListDistrict: [], // ✅ initialize
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      feedbackListColumns: [
        {
          dataField: "district",
          text: "District",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell) => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.districtFilter}
                  onChange={(e) => this.handleFilterChange("districtFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "equipment",
          text: "Equipment",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell) => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.equipmentFilter}
                  onChange={(e) =>
                    this.handleFilterChange("equipmentFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "participant_count",
          text: "Participant",
          sort: true,
          style: { textAlign: "center" },
          formatter: (cell, row) => {
            const count = row.participant_count || 0;
            if (count === 0) return "NS";
            return (
              <span
                style={{
                  color: "blue",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() =>
                  this.setState({
                    schemeModalOpen: true,
                    modalParticipantName: row.equipment,
                    hoveredSchemeNames: row.participants,
                  })
                }
              >
                {count}
              </span>
            );
          },
          headerFormatter: (column) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <input
                type="text"
                value={this.state.participantFilter}
                onChange={(e) =>
                  this.handleFilterChange("participantFilter", e)
                }
                className="form-control"
                style={{ width: "100px", marginTop: "5px" }}
              />
            </div>
          ),
        },

        {
          dataField: "manufacturer",
          text: "Manufacturer",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell) => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.manufacturerFilter}
                  onChange={(e) =>
                    this.handleFilterChange("manufacturerFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "origin",
          text: "Origin",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell) => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.originFilter}
                  onChange={(e) => this.handleFilterChange("originFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
      ],
    };
  }
  componentDidMount() {
    const { onGetAnalyte } = this.props;
    const { user_id } = this.state;

    if (user_id) {
      onGetAnalyte(user_id);
    }
  }

  fetchData() {
    const { onGetAnalyteReport1 } = this.props;
    const { analyteFilter } = this.state;

    if (analyteFilter) {
      // analyteFilter must be analyte_id, not name
      onGetAnalyteReport1(analyteFilter);
    }
  }
  componentDidUpdate(prevProps) {
    // Update analytes dropdown if list changes
    if (this.props.AnalyteList !== prevProps.AnalyteList) {
      this.setState({
        analytes: this.props.AnalyteList || [],
      });
    }

    if (this.props.GetAnalyte !== prevProps.GetAnalyte) {
      const analyte = this.props.GetAnalyte?.analyte || {};
      const schemes = this.props.GetAnalyte?.schemes || [];

      const flatLabs = [];

      (schemes || []).forEach((scheme) => {
        (scheme.rounds || []).forEach((round) => {
          (round.districts || []).forEach((district) => {
            (district.equipments || []).forEach((equipment) => {
              flatLabs.push({
                analyte_id: analyte.id,
                scheme_id: scheme.scheme_id,
                scheme_name: scheme.scheme_name,
                round_id: round.round_id,
                cycle_no: round.cycle_no,
                round_name: round.round_name,
                round_status: round.status,
                district: district.district || "N/A",
                equipment: equipment.equipment || "N/A",
                manufacturer: equipment.manufacturer || "N/A",
                origin: equipment.origin || "N/A",
                participant_count: equipment.participant_count || 0,
                participants: (equipment.participants || []).map((p) => ({
                  name: p.lab_name || "N/A",
                  district: p.district || district.district || "N/A",
                })),
              });
            });
          });
        });
      });

      this.setState({ tableData: flatLabs });

      this.setState({
        reportAnalyte: analyte,
        reportSchemes: schemes,
        GetAnalyte: flatLabs,
        filteredSchemes: schemes.map((s) => s.scheme_name),
        filteredCycles: [],
        filteredRounds: [],
        schemeFilter: "",
        cycleFilter: "",
        roundFilter: "",
      });
    }
  }

  handleSchemeChange = (selected) => {
    const selectedScheme = selected?.value === "All" ? "" : selected?.value;

    this.setState({
      schemeFilter: selectedScheme,
      cycleFilter: "",
      roundFilter: "",
      filteredRounds: [],
    });

    // Filter cycles for this scheme
    const cyclesForScheme =
      (this.state.reportSchemes || [])
        .find((s) => s.scheme_name === selectedScheme)
        ?.rounds.map((r) => r.cycle_no) || [];

    this.setState({
      filteredCycles: [...new Set(cyclesForScheme)],
    });
  };

  handleAnalyteChange = (selected) => {
    const selectedAnalyteId = selected?.value === "All" ? "" : selected?.value;

    this.setState({
      analyteFilter: selectedAnalyteId,
      schemeFilter: "",
      cycleFilter: "",
      roundFilter: "",
      filteredCycles: [],
      filteredRounds: [],
      GetAnalyte: [],
    });

    if (selectedAnalyteId) {
      const user_id = this.state.user_id;
      this.props.onGetAnalyteReport1(selectedAnalyteId, user_id);
    }
  };
  handleCycleChange = (selected) => {
    const selectedCycle = selected?.value === "All" ? "" : selected?.value;
    const selectedSchemeName = this.state.schemeFilter;

    const matchingSchemes = selectedSchemeName
      ? this.state.reportSchemes.filter(
          (s) => s.scheme_name === selectedSchemeName
        )
      : this.state.reportSchemes;

    let roundsForCycle = [];
    matchingSchemes.forEach((scheme) => {
      if (scheme.rounds) {
        const cycleRounds = scheme.rounds.filter(
          (r) => !selectedCycle || String(r.cycle_no) === String(selectedCycle)
        );
        roundsForCycle.push(...cycleRounds);
      }
    });

    roundsForCycle = [...new Set(roundsForCycle)];

    this.setState({
      cycleFilter: selectedCycle,
      roundFilter: "",
      filteredRounds: roundsForCycle,
    });
  };

  handleRoundChange = (selected) => {
    const selectedRound = selected?.value === "All" ? "" : selected?.value;
    console.log("🎯 Selected Round:", selectedRound);

    // Use filteredSchemes from Cycle if available, fallback to reportSchemes
    const { filteredSchemes, reportSchemes } = this.state;
    const sourceSchemes =
      (filteredSchemes && filteredSchemes.length > 0
        ? filteredSchemes
        : reportSchemes) || [];

    console.log(
      "🔍 Available Rounds:",
      sourceSchemes.flatMap((s) => (s.rounds || []).map((r) => r.round_name))
    );

    // 🧩 Diagnostic Log — Check if rounds actually have districts/equipments
    console.log(
      "🧩 All Rounds with Districts:",
      sourceSchemes.flatMap((s) =>
        (s.rounds || []).map((r) => ({
          round_name: r.round_name,
          cycle_no: r.cycle_no,
          hasDistricts: r.districts && r.districts.length > 0,
          districtCount: (r.districts || []).length,
          hasEquipments: (r.districts || []).some(
            (d) => (d.equipments || []).length > 0
          ),
        }))
      )
    );

    // Defer filtering slightly to allow setState updates to settle
    setTimeout(() => {
      const filteredData = sourceSchemes.flatMap((scheme) =>
        (scheme.rounds || [])
          .filter(
            (round) => !selectedRound || round.round_name === selectedRound
          )
          .flatMap((round) =>
            (round.districts || []).flatMap((district) =>
              (district.equipments || []).map((equipment) => ({
                analyte_id: this.state.reportAnalyte?.id,
                scheme_name: scheme.scheme_name,
                cycle_no: round.cycle_no,
                round_name: round.round_name,
                district: district.district,
                equipment: equipment.equipment,
                manufacturer: equipment.manufacturer,
                origin: equipment.origin,
                participant_count: equipment.participant_count,
                participants: equipment.participants || [],
              }))
            )
          )
      );

      console.log("📊 Filtered Data for Table:", filteredData);
      console.log("📦 All Flattened Data:", sourceSchemes);

      this.setState({
        roundFilter: selectedRound,
        GetAnalyte: filteredData,
      });
    }, 100);
  };

  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };

  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  handleFilterChange = (filterName, e) => {
    const value = e.target.value;
    this.setState({
      [filterName]: value,
      currentPage: 1, // ✅ reset pagination to first page when filter changes
    });
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };
  filterData = () => {
    const {
      GetAnalyte,
      analyteFilter = "",
      districtFilter = "",
      participantFilter = "",
      manufacturerFilter = "",
      originFilter = "",
      equipmentFilter = "",
      schemeFilter = "",
      cycleFilter = "",
      roundFilter = "",
    } = this.state;

    // ✅ Only return data if an analyte is selected
    if (!analyteFilter) return [];

    // Ensure GetAnalyte is always an array
    const analyteList = Array.isArray(GetAnalyte) ? GetAnalyte : [GetAnalyte];

    return analyteList.filter(
      (entry) =>
        (entry.analyte_id || "").toString() === analyteFilter.toString() &&
        (entry.district || "")
          .toLowerCase()
          .includes(districtFilter.toLowerCase()) &&
        String(entry.participant_count || "")
          .toLowerCase()
          .includes(participantFilter.toLowerCase()) && // ✅ fixed line
        (entry.equipment || "")
          .toLowerCase()
          .includes(equipmentFilter.toLowerCase()) &&
        (entry.manufacturer || "")
          .toLowerCase()
          .includes(manufacturerFilter.toLowerCase()) &&
        (entry.origin || "")
          .toLowerCase()
          .includes(originFilter.toLowerCase()) &&
        (entry.scheme_name || "")
          .toLowerCase()
          .includes(schemeFilter.toLowerCase()) &&
        (entry.cycle_no || "").toString().includes(cycleFilter.toString()) &&
        (entry.round_name || "")
          .toLowerCase()
          .includes(roundFilter.toLowerCase())
    );
  };

  getUniqueOptions = (fieldName) => {
    // Always use full data, not filtered
    const allData = this.state.GetAnalyte || [];
    const options = new Set();

    allData.forEach((item) => {
      const value = item[fieldName];
      if (Array.isArray(value)) {
        value.forEach((v) => options.add(v));
      } else if (value) {
        options.add(value);
      }
    });

    return Array.from(options);
  };

  checkFiltersApplied = () => {
    const {
      nameFilter,
      idFilter,
      districtFilter,
      participantFilter,
      equipmentFilter,
      manufacturerFilter,
      originFilter,
      schemeFilter,
      schemepriceFilter,
    } = this.state;

    // Check if ANY filter is applied AND has a NON-EMPTY value
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      participantFilter,
      equipmentFilter,
      manufacturerFilter,
      originFilter,
      schemeFilter,
      schemepriceFilter,
    ];

    const anyFilterSelected = filters.some((f) => f && f.trim() !== "");

    this.setState({ filtersApplied: anyFilterSelected });
  };

  render() {
    const { GetAnalyte } = this.state;
    const { onGetAnalyte } = this.props;
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const { ListDistrict } = this.state;
    const districtOptions = (this.state.ListDistrict || []).map((district) => ({
      value: district.name,
      label: district.name,
    }));
    console.log("📊 Filtered Data for Table:", this.filterData());
    console.log("📦 All Flattened Data:", this.state.GetAnalyte);
    const pageOptions = {
      sizePerPage: 50,
      totalSize: this.filterData().length,
      custom: true,
      onPageChange: (page, sizePerPage) => {
        this.setState({ currentPage: page });
      },
    };
    const roundColumns = (this.state.selectedSchemeRounds || []).map(
      (round, index) => ({
        dataField: `round_${index + 1}`,
        text: `Round ${index + 1}`,
        sort: true,
        style: { textAlign: "center" },
        formatter: (cell, row) => {
          if (!cell || cell.count === 0) return "NS";
          return (
            <span
              style={{
                color: "blue",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() =>
                this.setState({
                  schemeModalOpen: true,
                  modalParticipantName: `Round ${index + 1}`,
                  hoveredSchemeNames: cell.participants || [], // ✅ use participants
                })
              }
            >
              {cell.count}
            </span>
          );
        },
        headerFormatter: (column) => (
          <div style={{ textAlign: "center" }}>{column.text}</div>
        ),
      })
    );

    const allColumns = [...this.state.feedbackListColumns, ...roundColumns];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Analyte Report | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="Analyte REPORT - 1" />
            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                {" "}
                {/* <p>
                  <strong>Note:</strong> Click on Scheme Number to get detail of
                  each participants payments
                </p> */}
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={this.filterData()}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={allColumns}
                          data={this.filterData()}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Modal
                                isOpen={this.state.schemeModalOpen}
                                toggle={this.handleSchemeModalClose}
                              >
                                <ModalHeader
                                  toggle={this.handleSchemeModalClose}
                                >
                                  Scheme Details for{" "}
                                  {this.state.modalParticipantName || "Unknown"}
                                </ModalHeader>
                                <ModalBody>
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th className="text-start">
                                          Participant Name
                                        </th>
                                        <th className="text-start">District</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(
                                        this.state.hoveredSchemeNames || []
                                      ).map((p, idx) => (
                                        <tr key={idx}>
                                          <td className="text-start">
                                            {p.name || "N/A"}
                                          </td>
                                          <td className="text-start">
                                            {p.district || "N/A"}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </ModalBody>
                              </Modal>

                              <Row className="mb-3">
                                <Col md={4}>
                                  <Label for="analyteFilter">Analyte</Label>
                                  <Select
                                    id="analyteFilter"
                                    options={[
                                      { value: "All", label: "All Analytes" },
                                      ...(this.state.analytes || []).map(
                                        (a) => ({
                                          value: a.id,
                                          label: a.name,
                                        })
                                      ),
                                    ]}
                                    value={
                                      this.state.analyteFilter
                                        ? {
                                            value: this.state.analyteFilter,
                                            label:
                                              (this.state.analytes || []).find(
                                                (a) =>
                                                  a.id ===
                                                  this.state.analyteFilter
                                              )?.name || "",
                                          }
                                        : null
                                    }
                                    onChange={(selected) => {
                                      const selectedAnalyteId =
                                        selected?.value === "All"
                                          ? ""
                                          : selected?.value;
                                      this.handleFilterChange("analyteFilter", {
                                        target: { value: selectedAnalyteId },
                                      });

                                      this.setState({
                                        schemeFilter: "",
                                        cycleFilter: "",
                                        roundFilter: "",
                                        filteredSchemes: [],
                                        filteredCycles: [],
                                        filteredRounds: [],
                                        GetAnalyte: [],
                                      });

                                      if (selectedAnalyteId) {
                                        const user_id = this.state.user_id;
                                        this.props.onGetAnalyteReport1(
                                          selectedAnalyteId,
                                          user_id
                                        );
                                      }
                                    }}
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="schemeFilter">Scheme</Label>
                                  <Select
                                    id="schemeFilter"
                                    options={[
                                      { value: "All", label: "All Schemes" },
                                      ...(this.state.filteredSchemes || []).map(
                                        (s) => ({ value: s, label: s })
                                      ),
                                    ]}
                                    value={
                                      this.state.schemeFilter
                                        ? {
                                            value: this.state.schemeFilter,
                                            label: this.state.schemeFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) => {
                                      const scheme =
                                        selected?.value === "All"
                                          ? ""
                                          : selected?.value;
                                      this.handleFilterChange("schemeFilter", {
                                        target: { value: scheme },
                                      });

                                      // Update cycles based on selected scheme
                                      const cycles =
                                        (this.state.reportSchemes || [])
                                          .find((s) => s.scheme_name === scheme)
                                          ?.rounds.map((r) => r.cycle_no) || [];

                                      this.setState({
                                        cycleFilter: "",
                                        roundFilter: "",
                                        filteredCycles: [...new Set(cycles)],
                                        filteredRounds: [],
                                      });
                                    }}
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="cycleFilter">Cycle</Label>
                                  <Select
                                    id="cycleFilter"
                                    options={[
                                      { value: "All", label: "All Cycles" },
                                      ...(this.state.filteredCycles || []).map(
                                        (cycle) => ({
                                          value: cycle,
                                          label: cycle,
                                        })
                                      ),
                                    ]}
                                    value={
                                      this.state.cycleFilter
                                        ? {
                                            value: this.state.cycleFilter,
                                            label: this.state.cycleFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) => {
                                      const selectedCycle =
                                        selected?.value === "All"
                                          ? ""
                                          : selected?.value;
                                      const selectedSchemeName =
                                        this.state.schemeFilter;

                                      // Filter rounds for the selected cycle and scheme
                                      const roundsForCycle = (
                                        this.state.reportSchemes || []
                                      )
                                        .filter(
                                          (s) =>
                                            !selectedSchemeName ||
                                            s.scheme_name === selectedSchemeName
                                        )
                                        .flatMap((s) =>
                                          (s.rounds || []).filter(
                                            (r) =>
                                              !selectedCycle ||
                                              r.cycle_no === selectedCycle
                                          )
                                        );

                                      this.setState({
                                        cycleFilter: selectedCycle,
                                        roundFilter: "",
                                        filteredRounds: roundsForCycle, // store full round objects
                                      });
                                    }}
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="roundFilter">Round</Label>
                                  <Select
                                    id="roundFilter"
                                    options={[
                                      { value: "All", label: "All Rounds" },
                                      ...(this.state.filteredRounds || []).map(
                                        (r) => ({
                                          value: r.round_name, // only string or number
                                          label: r.round_name,
                                        })
                                      ),
                                    ]}
                                    value={
                                      this.state.roundFilter
                                        ? {
                                            value: this.state.roundFilter,
                                            label: this.state.roundFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) => {
                                      const selectedRoundName =
                                        selected?.value === "All"
                                          ? ""
                                          : selected?.value;

                                      // Flatten table data for the selected round
                                      const filteredData =
                                        this.state.reportSchemes.flatMap(
                                          (scheme) =>
                                            (scheme.rounds || [])
                                              .filter(
                                                (r) =>
                                                  !selectedRoundName ||
                                                  r.round_name ===
                                                    selectedRoundName
                                              )
                                              .flatMap((round) =>
                                                (round.districts || []).flatMap(
                                                  (district) =>
                                                    (
                                                      district.equipments || []
                                                    ).map((equipment) => ({
                                                      analyte_id:
                                                        this.state.reportAnalyte
                                                          ?.id,
                                                      scheme_name:
                                                        scheme.scheme_name,
                                                      cycle_no: round.cycle_no,
                                                      round_name:
                                                        round.round_name,
                                                      district:
                                                        district.district ||
                                                        "N/A",
                                                      equipment:
                                                        equipment.equipment ||
                                                        "N/A",
                                                      manufacturer:
                                                        equipment.manufacturer ||
                                                        "N/A",
                                                      origin:
                                                        equipment.origin ||
                                                        "N/A",
                                                      participant_count:
                                                        equipment.participant_count ||
                                                        0,
                                                      participants: (
                                                        equipment.participants ||
                                                        []
                                                      ).map((p) => ({
                                                        name:
                                                          p.lab_name || "N/A",
                                                        district:
                                                          p.district ||
                                                          district.district ||
                                                          "N/A",
                                                      })),
                                                    }))
                                                )
                                              )
                                        );

                                      this.setState({
                                        roundFilter: selectedRoundName,
                                        GetAnalyte: filteredData,
                                      });
                                    }}
                                    isClearable
                                  />
                                </Col>

                                <Row></Row>
                              </Row>

                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-condensed table-hover"
                                      }
                                      bordered={false}
                                      striped={true}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AnalyteReport1.propTypes = {
  GetAnalyte: PropTypes.array,
  AnalyteReport2: PropTypes.object,
  onGetAnalyteReport1: PropTypes.func,
  AnalyteList: PropTypes.array,
  onGetAnalyte: PropTypes.func,
  match: PropTypes.object,
};
const mapStateToProps = (state) => ({
  AnalyteList: state.ListUnit.ListUnit, // analytes dropdown
  GetAnalyte: state.ListUnit.GetAnalyte, // report1 data
});

const mapDispatchToProps = (dispatch) => ({
  onGetAnalyteReport1: (id) => dispatch(getanalytereport1(id)),
  onGetAnalyte: (id) => dispatch(getAnalytelist(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalyteReport1);
